<div class="navbar-wrapper">
  <div class="logo-container">
    <img src="assets/img/start-page/HVB_Logo.svg" class="cursor-pointer" alt="HVB Logo"/>
  </div>
</div>

<div *ngIf="this.router.url === '/Tutorial?id='+this.id && this.id !== ''" class="main-outer-div flex-grow-1 flex-shrink-1 pt-4">
  <div class="left form-title-section-text">
    <h1>{{ 'tutorial.tutorialTitle' | translate }}</h1>
    <h4>{{ 'tutorial.tutorialSubtitle' | translate }}</h4>
  </div>
  <div  class="d-flex flex-column " style="float: right; width: 100%">
    <div id="video">
      <iframe [src]="videoUrl"
              allow="autoplay; fullscreen; picture-in-picture"
              title="{{'help.releaseHelp.1-1.title'|translate}}"></iframe>
    </div>
  </div>
</div>

<div *ngIf="this.router.url === '/Onboarding'" class="main-outer-div flex-grow-1 flex-shrink-1 pt-4">
  <div class="left form-title-section-text">
    <h1>{{ 'tutorial.onboardingTitle' | translate }}</h1>
    <h4>{{ 'tutorial.onboardingSubtitle' | translate }}</h4>
  </div>
  <div  class="d-flex flex-column " style="float: right; width: 100%">
    <div id="video"><iframe src="https://player.vimeo.com/video/879777309?h=23a6b0af57&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" allow="autoplay; fullscreen; picture-in-picture" title="{{ 'tutorial.onboardingTitle' | translate }}"></iframe></div>
  </div>
</div>

<div *ngIf="this.router.url === '/OnboardingCA'" class="main-outer-div flex-grow-1 flex-shrink-1 pt-4">
  <div class="left form-title-section-text">
    <h1>{{ 'tutorial.onboardingCATitle' | translate }}</h1>
    <h4>{{ 'tutorial.onboardingCASubtitle' | translate }}</h4>
  </div>
  <div  class="d-flex flex-column " style="float: right; width: 100%">
    <div id="video"><iframe src="https://player.vimeo.com/video/880463226?h=830fb6cb46&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" allow="autoplay; fullscreen; picture-in-picture" title="{{ 'tutorial.onboardingCATitle' | translate }}"></iframe></div>
  </div>
</div>

<div *ngIf="this.router.url === '/Showcase'" class="main-outer-div flex-grow-1 flex-shrink-1 pt-4">
  <div class="left form-title-section-text">
    <h1>{{ 'tutorial.showcaseTitle' | translate }}</h1>
    <h4>{{ 'tutorial.showcaseSubtitle' | translate }}</h4>
  </div>
  <div  class="d-flex flex-column " style="float: right; width: 100%">
    <div id="video"><iframe src="https://player.vimeo.com/video/889435287?h=be1ff191e3&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" allow="autoplay; fullscreen; picture-in-picture" title="{{ 'tutorial.showcaseTitle' | translate }}"></iframe></div>
  </div>
</div>
<script src="https://player.vimeo.com/api/player.js" integrity="23d8557a27e6e42b55fdacbe7adfe0fe6408132ebbdf6c36563ac49e0c8c6c02" crossorigin="anonymous"></script>

